import { ErrorMessage, Field } from "formik";

export const CustomField = ({
  name,
  label,
  type = "text",
  placeholder = label,
}) => {
  return (
    <div className="field">
      <label htmlFor={name}>{label}</label>
      <Field
        className="input-field"
        type={type}
        name={name}
        placeholder={placeholder}
        style={{ width: "250px" }}
      />
      <ErrorMessage name={name} component="div" className="error-message" />
    </div>
  );
};
